import React from 'react';
import {ScoreCircleProps} from './ScoreCircle.props';
import './ScoreCircle.css';
import {Box, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { roundPhishFitScore } from '../../utils/util';

export const ScoreCircle: React.FC<ScoreCircleProps> = (props) => {
    const {score, progress = 0} = props
    const getColor = (value: number) => {
        if (value >= 100) return "#7CB342";
        if (value >= 80) return "#6EC1E4";
        if (value >= 70) return "#F4B400";
        if (value >= 40) return "#FF9800";
        if (value >= 0) return "#F44336";
        return "#BDBDBD";
    };
    
    if (score === null || score === undefined) {
        return (
            <Typography variant="body2" textAlign="left">
                No Score
            </Typography>
        );
    }
    
    const displayScore = roundPhishFitScore(score)

    return (
        <Box
            sx={{
                position: "relative",
                width: 30,
                height: 30,
                display: "inline-flex",
            }}
            className={'score-circle'}
        >
            <CircularProgress
                variant="determinate"
                value={Math.min(progress, 100)}
                size={30}
                thickness={5}
                sx={{
                    color: getColor(displayScore),
                    position: "absolute",
                }}
                className={'score-circle-progress'}
            />

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                }}
                className={'score-circle-score'}
            >
                <Typography
                    sx={{
                        fontSize: 10,
                        fontWeight: 700,
                        textAlign: 'center',
                    }}
                    className={'score-circle-label'}
                >
                    {displayScore}
                </Typography>
            </Box>
        </Box>
    );
};
